import React from "react";
import PropTypes from "prop-types";
import {Element} from "react-scroll";
import Material from "../ProductMaterial";
import Printing from "../ProductPrinting";
import Price from "../ProductPrice";
import Size from "../ProductSize";
import Delivery from "../ProductDelivery";
import Reviews from "../ProductReviews";
import Description from "../ProductDescription";
import withErrorBoundary from "../../../decorators/withErrorBoundary";

import styles from "./contents.module.scss";

function getContentById(id, props) {
  switch (id) {
    case `description`:
      return <Description {...props} />;
    case `material`:
      return <Material {...props} />;
    case `printing`:
      return <Printing {...props} />;
    case `price`:
      return <Price {...props} />;
    case `size`:
      return <Size {...props} />;
    case `delivery`:
      return <Delivery {...props} />;
    case `reviews`:
      return <Reviews {...props} />;
    default:
      return void 0;
  }
}

function Contents(props) {
  const {
    productName,
    items,
    seo,
    locationData,
    reviews,
    priceList,
    onPlatform,
    itemDescription
  } = props;
  return (
    <div className={styles.root}>
      {items.map((params) => (
        <section key={params.id} className={styles.item}>
          <Element name={`${productName}-${params.id}`}>
            {getContentById(params.id, {
              ...params,
              seo,
              locationData,
              reviews,
              priceList,
              onPlatform,
              itemDescription
            })}
          </Element>
        </section>
      ))}
    </div>
  );
}

Contents.propTypes = {
  productName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    })
  ),
  seo: PropTypes.object,
  locationData: PropTypes.object,
  reviews: PropTypes.object,
  priceList: PropTypes.string,
  onPlatform: PropTypes.string
};

export default withErrorBoundary(Contents);
